import { render, staticRenderFns } from "./input2PuntosMuestreo.vue?vue&type=template&id=c1d3c478"
import script from "./input2PuntosMuestreo.vue?vue&type=script&lang=js"
export * from "./input2PuntosMuestreo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports